import FingerprintJS from '@fingerprintjs/fingerprintjs';
import type { AxiosError } from 'axios';
import { FINGER_PRINT } from 'const/local-storage';
import posthog from 'posthog-js';

const getFingerprint = async () => {
  try {
    const fingerprint = localStorage.getItem(FINGER_PRINT);
    if (fingerprint) return fingerprint;

    const fpPromise = await FingerprintJS.load();
    const result = await fpPromise.get();
    localStorage.setItem(FINGER_PRINT, result.visitorId);
    return result.visitorId;
  } catch (e) {
    posthog?.capture('getFingerprintFailed', { error: (e as AxiosError).message });
    console.warn(`fingerprinting failed message: ${(e as Error).message}`);
  }
};

export default getFingerprint;
